// extracted by mini-css-extract-plugin
export default {"risksTitle":"W4HbDm7TYdHr8WOtPO7P","showAllScoresRow":"rTXJQ6FJ8UrtjxTFCUtM","showAllScores":"i221ghvSVxZgeeE1JkAA"};